document.addEventListener('click', (e) => {
  const button = e.target.closest('.temp_regime, .fragile, .no_turn');
  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  const noteField = document.querySelector("textarea[name='destination[notes]']");
  if (noteField) noteField.value += button.textContent.trim() + ", ";
});
